import React from 'react';

export const AlignCenter = () => (
  <svg viewBox="0 0 38 38">
    <path className="cls-b3 illus-clr-1" d="M20 29L20 9L18 9L18 29L20 29Z" />
    <path
      className="cls-b3 illus-clr-1"
      d="M24.5385 20C25.8972 20 27 20.896 27 22L27 25C27 26.104 25.8972 27 24.5385 27L13.4615 27C12.1028 27 11 26.104 11 25L11 22C11 20.896 12.1028 20 13.4615 20L24.5385 20Z"
    />
    <path
      className="cls-b1 illus-clr-2"
      d="M22 11C23.104 11 24 11.896 24 13L24 16C24 17.104 23.104 18 22 18L16 18C14.896 18 14 17.104 14 16L14 13C14 11.896 14.896 11 16 11L22 11Z"
    />
  </svg>
);
